import { createNotification } from 'react-redux-notify';
import { select, put, takeLatest, all } from 'redux-saga/effects';

import api from '../../Environment';
import {
  FETCH_WALLET_DETAILS_START,
  ADD_MONEY_VIA_CARD_START,
  FETCH_REVERSED_TRANSACTION_START,
  GET_TRANSACTION_HISTORY_START,
} from '../actions/ActionConstant';
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from '../../components/helper/NotificationMessage';
import {
  fetchWalletHistoryStart,
  addMoneyViaCardSuccess,
  addMoneyViaCardFailure,
  fetchWalletHistorySuccess,
  fetchEarningSummaryStart,
  fetchWalletDetailsFailure,
  fetchWalletDetailsSuccess,
  fetchIncomeWalletHistoryStart,
  fetchReversedTransactionSuccess,
  fetchReversedTransactionFailure,
  fetchTransactionHistoryFailure,
  fetchTransactionHistorySuccess,
} from '../actions/WalletAction';
import {
  FETCH_WALLET_HISTORY_START,
  FETCH_INCOME_WALLET_HISTORY_START,
} from '../actions/ActionConstant';
import { checkLogoutStatus } from '../actions/ErrorAction';
import { fetchWithDrawalsStart } from '../actions/WithDrawAction';
import { fetchWalletDetailsStart } from '../actions/WalletAction';
import { fetchWalletHistoryFailure } from '../actions/WalletAction';
import { fetchEarningSummarySuccess } from '../actions/WalletAction';
import UserPaymentService from "../../helpers/services/payment/user";
import { fetchEarningSummaryFailture } from '../actions/WalletAction';
import { FETCH_EARNING_SUMMARY_START } from '../actions/ActionConstant';
import { PerformerStatementTabs } from '../../components/Hub/PerformerStatements';
import { parsePaymentServiceError } from "../../helpers/services/payment/error";
import walletService from "../../helpers/services/payment/wallet";
import { showErrorComponent } from '../actions/ComponentAction';

function* fetchWalletDetailsAPI() {
  try {
    const response = yield api.postAuthMethod('wallets_index');
    if (response.data.success) {
      yield put(fetchWalletDetailsSuccess(response.data.data));
      // Do nothing
    } else {
      yield put(checkLogoutStatus(response.data));
      yield put(fetchWalletDetailsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchWalletDetailsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.response.data.error);
    yield put(createNotification(notificationMessage));
  }
}

function* addMoneyViaCardAPI() {
  try {
    const inputData = yield select((state) => state.wallet.addMoneyViaCard.data);
    const response = yield walletService.loadToWallet(inputData)
    
    yield put(addMoneyViaCardSuccess(response.data.data));
    const notificationMessage = getSuccessNotificationMessage(response.data.message);
    yield put(createNotification(notificationMessage));
    yield put(fetchWalletDetailsStart());
    switch (inputData.selectedTab) {
      case PerformerStatementTabs[0].label:
        return yield put(fetchWalletHistoryStart());
      case PerformerStatementTabs[1].label:
        return yield put(fetchIncomeWalletHistoryStart());
      case PerformerStatementTabs[2].label:
        return yield put(fetchWithDrawalsStart());
      case PerformerStatementTabs[3].label:
        return yield put(fetchEarningSummaryStart());
      default:
        return yield put(fetchWalletHistoryStart());
    }
  } catch (error) {
    const message = parsePaymentServiceError(error.response);
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(addMoneyViaCardFailure(message));
    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchWalletHistoryApi() {
  try {
    const response = yield api.postAuthMethod('wallets_history_spending');
    if (response.data.success) {
      yield put(fetchWalletHistorySuccess(response.data.data));
    } else {
      yield put(fetchWalletHistoryFailure(response.data.error));
    }
  } catch (error) {
    yield put(fetchWalletHistoryFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchIncomeWalletHistoryApi() {
  try {
    const response = yield api.postAuthMethod('wallets_history_income');
    if (response.data.success) {
      yield put(fetchWalletHistorySuccess(response.data.data));
    } else {
      yield put(fetchWalletHistoryFailure(response.data.error));
    }
  } catch (error) {
    yield put(fetchWalletHistoryFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchEarningSummaryApi() {
  try {
    const response = yield api.postAuthMethod('wallets_summary');
    if (response.data.success) {
      yield put(fetchEarningSummarySuccess(response.data.data));
    } else {
      yield put(fetchEarningSummaryFailture(response.data.error));
    }
  } catch (error) {
    yield put(fetchEarningSummaryFailture(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchRevertedTransactions() {
  try {
    const response = yield UserPaymentService.fetchRevertedTransactions();
    yield put(fetchReversedTransactionSuccess(response));
  } catch (error) {
    yield put(fetchReversedTransactionFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchTransactionHistory(action) {
  try {
    const response = yield walletService.fetchTransactionHistory(action.payload)
    if (response.data.success) {
      yield put(fetchTransactionHistorySuccess({
        transactionHistory: response.data?.data?.result || [],
        pagination: response?.data?.data?.metadata?.pagination || {}
      }));
    } else {
      yield put(fetchTransactionHistoryFailure(response.data.message));
      const notificationMessage = getErrorNotificationMessage(response.data.message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchTransactionHistoryFailure(error));
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
  }
}

export default function* pageSaga() {
  yield all([
    yield takeLatest(FETCH_WALLET_DETAILS_START, fetchWalletDetailsAPI),
    yield takeLatest(ADD_MONEY_VIA_CARD_START, addMoneyViaCardAPI),
    yield takeLatest(FETCH_WALLET_HISTORY_START, fetchWalletHistoryApi),
    yield takeLatest(FETCH_INCOME_WALLET_HISTORY_START, fetchIncomeWalletHistoryApi),
    yield takeLatest(FETCH_EARNING_SUMMARY_START, fetchEarningSummaryApi),
    yield takeLatest(FETCH_REVERSED_TRANSACTION_START, fetchRevertedTransactions),
    yield takeLatest(GET_TRANSACTION_HISTORY_START, fetchTransactionHistory),
  ]);
}
